/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MeFollowResponse } from "./MeFollowResponse";

export type MeFollowResponseApiRespoonse = {
  data?: MeFollowResponse;
  status?: MeFollowResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MeFollowResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
